import React, { Fragment, useState } from 'react';
import {Box,IconButton} from '@material-ui/core'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment-timezone'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
function Laperut(props) {
    const [Value1,setValue1] = React.useState(new Date())
    const [Value2,setValue2] = React.useState(new Date())
    const [Label,setLabel] = React.useState(props.Label)
    const FromInput = props.intl.formatMessage({ id: 'Input.From' });
    const ToInput = props.intl.formatMessage({ id: 'Input.To' });
    const onchangeHandle1=(date)=>{setValue1(date)}
    const onchangeHandle2=(date)=>{setValue2(date)}
    const updateValues=async ()=>{
        //props.handleChange(`${props.Meta}From`,Value1,`${props.Meta}To`,Value2)
        props.handleChange(`${props.Meta}From`,moment(Value1).format("YYYY-MM-DD"),`${props.Meta}To`,moment(Value2).format("YYYY-MM-DD"))
        setValue1(new Date())
        setValue2(new Date())
    }
    return (
        <Box display="flex" p={0} m={0} style={{ margin: '0',width:"100%" }}>
           <Box p={0} flexGrow={1}>
           <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
      <Fragment>
           <KeyboardDatePicker
           fullWidth
           defaultValue=""
           invalidDateMessage={<IntlMessages id="Date.inValid"/>}
           inputVariant="outlined"
           variant="dialog"
           format="yyyy-MM-dd"
           size="small"
           cancelLabel={<IntlMessages id="Cancel"/>}
           name="title"
           label={<>{props.Label} {FromInput}</>}
           value={Value1}
           InputLabelProps={{ shrink: true }}
           onChange={onchangeHandle1}
           KeyboardButtonProps={{
            "class": "px-0 m-0 btn btn-sm"
           }}
            />
            </Fragment>
            </MuiPickersUtilsProvider>
            </Box> 
        <Box p={0}>  
            <b className="d-flex justify-content-center mx-3" style={{ margin: '0', fontSize: 22 }}>-</b>
        </Box> 
           <Box p={0} flexGrow={1}>
           <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
      <Fragment>
           <KeyboardDatePicker
           fullWidth
           defaultValue=""
           format="yyyy-MM-dd"
           inputVariant="outlined"
           invalidDateMessage={<IntlMessages id="Date.inValid"/>}
           variant="dialog"
           size="small"
           cancelLabel={<IntlMessages id="Cancel"/>}
           name="title"
           label={<>{props.Label} {ToInput}</>}
           value={Value2}
           InputLabelProps={{ shrink: true }}
           onChange={onchangeHandle2}
           KeyboardButtonProps={{
            "class": "px-0 m-0 btn btn-sm"
           }}
           /></Fragment>
           </MuiPickersUtilsProvider>
               </Box> 
               <Box p={0}>  
        <IconButton
          color="primary"
          size="small"
          aria-label="upload picture"
          component="span"
          onClick={updateValues}
        >
          <CheckIcon />
        </IconButton>
        </Box> 
        </Box>
    );
}

export default injectIntl(Laperut);